import trip from './trip'
import journey from './journey'
export default {
  trip,
  journey
}
